import { render, staticRenderFns } from "./MatrixChart.vue?vue&type=template&id=a491670a&scoped=true"
import script from "./MatrixChart.vue?vue&type=script&lang=js"
export * from "./MatrixChart.vue?vue&type=script&lang=js"
import style0 from "./MatrixChart.vue?vue&type=style&index=0&id=a491670a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a491670a",
  null
  
)

export default component.exports